import { IcContactModel } from './IcContactModel';
import { useRefListener, useWidget } from '../../widget/sgwt-configuration';
import { v4 as uuidv4 } from 'uuid';

export interface IcContactsJsonSchemaWidgetProps {
  onChange: (newValues: string[]) => void;
  value: IcContactModel[];
  placeholder?: string;
}

export const flattenIcContacts = (contacts: IcContactModel[]): string[] =>
  contacts.map((contact: IcContactModel) => contact.id);

export const IcContactsJsonSchemaWidget = ({ onChange, value, placeholder }: IcContactsJsonSchemaWidgetProps): JSX.Element => {
  useWidget('https://shared.sgmarkets.com/ic-widgets/v1/ic-contact-multi-picker');

  const handleChange = (contacts: IcContactModel[]): void => {
    onChange(contacts.map((contact: IcContactModel) => contact.id));
  };

  const ref = useRefListener<IcContactModel[]>('ic-contact-multi-picker--changed', handleChange);

  const selectedIds = value && Array.isArray(value) ? `[${value.map((contact: IcContactModel) => contact.id).join()}]` : '[]';

  return (
    <ic-contact-multi-picker
      ref={ref}
      id={uuidv4()}
      placeholder={placeholder}
      selected-ids={selectedIds}
      max-result-count={100}
    />
  );
};
